const IndependentSection = () => {
  return (
    <section className="bg-white py-56">
      <div className="w-4/5 mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="border border-[#E5E7EB] rounded-lg p-12 bg-[#FAFAFA]">
            <div className="w-24 h-px bg-[#2B2D33] mb-8"></div>
            <h2
              className="text-4xl font-light text-[#2B2D33] leading-tight mb-8"
              style={{ fontFamily: 'Crimson Text, serif' }}
            >
              Independent — No Software Sales
            </h2>

            <p className="text-lg text-[#6B6D72] leading-relaxed">
              We do not sell software, receive referral commissions, or implement technology platforms. Our guidance is independent, objective, and focused solely on enterprise value improvement.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndependentSection;
